import { Injectable } from '@angular/core';
import { animationFrameScheduler, fromEventPattern, Subject } from 'rxjs';
import { auditTime, takeUntil, tap } from 'rxjs/operators';

@Injectable()
export class SyncPaneWidthService {
    private _primary: string;
    private _others: string[];
    private readonly _done: Subject<void>;
    private _mutationObserver: MutationObserver;

    constructor() {
        this._done = new Subject();
    }

    setPrimary(selector: string): void {
        this._primary = selector;
    }

    addOthers(selectors: string[]): void {
        this._others = this._others || [];
        // eslint-disable-next-line @typescript-eslint/prefer-includes
        this._others.push(
            // eslint-disable-next-line @typescript-eslint/prefer-includes
            ...selectors.filter((e) => this._others.indexOf(e) === -1),
        );
    }

    reset(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._mutationObserver && this._mutationObserver.disconnect();
        this._mutationObserver = null;
        this._done.next();
        this._primary = null;
        this._others = null;
    }

    run(container: HTMLElement): void {
        let prevEl: HTMLElement;
        this._mutationObserver = new MutationObserver(() => {
            // could use Node.isConnected but ie11, or maybe primaryEl.getBoundingClientRect().width === 0
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            const el = (container || document).querySelector(
                this._primary,
            ) as HTMLElement;
            if (el === prevEl) {
                // console.log('still in dom');
                return;
            }
            if (el) {
                prevEl = el;
                this._run(container, el);
                // this._mutationObserver.disconnect();
                console.log('something');
            }
        });

        // const primaryEl = (container || document).querySelector(this._primary) as HTMLElement;
        if (/*! primaryEl && */ !container) {
            console.warn('nothing');
        }
        // if (!primaryEl && container) {
        this._mutationObserver.observe(container, {
            childList: true,
            subtree: true,
        });
        // }
        /* if (primaryEl) {
            this._run(container, primaryEl);
        } */
    }

    private _run(container: HTMLElement, primaryEl: HTMLElement): void {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        const resizeObserver = window['ResizeObserver']; /* || ResizeObserver */
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (resizeObserver === window['ResizeObserver']) {
            console.log('using native resize observer');
        }

        this._done.next();
        let ro;
        fromEventPattern(
            (handler) => {
                // eslint-disable-next-line new-cap
                ro = new resizeObserver(handler);
                ro.observe(primaryEl);
            },
            () => {
                ro.disconnect();
            },
        )
            .pipe(
                auditTime(0, animationFrameScheduler),
                tap(() => this._applyWidth(container, primaryEl)),
                takeUntil(this._done),
            )
            .subscribe();
    }

    private _applyWidth(container: HTMLElement, primaryEl: HTMLElement): void {
        const width = primaryEl.getBoundingClientRect().width;
        const widthStr = width === 0 ? null : `${width}px`; // TODO check ie11. 0 when not connected
        this._others.forEach((e) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            const el = (container || document).querySelector(e) as HTMLElement;
            if (el) {
                el.style.width = widthStr;
                el.style.minWidth = widthStr;
                // el.style.maxWidth = widthStr;
            }
        });
    }
}
